import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationIncotermsPluginService } from './incoterms.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';

@Component({
    selector: 'installation-incoterms-edit',
    templateUrl: './incoterms-edit.component.html',
    standalone: false
})
export class InstallationIncotermsEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  incoterms: any[];

  @ViewChild('incotermsModal', { static: true }) incotermsModal: ModalComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationIncotermsPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateIncoterms(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['value'].markAsTouched();
  }

  public openIncotermsSelector() {
    this.openSelector(this.incotermsModal, this.incoterms, this.editForm.controls.value.value);
  }

  public selectIncotermsMenu(item: any) {
    const selectedIndex = this.editForm.controls.value.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.value.setValue(selectedIndex);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.incoterms = this.pluginService.getIncoterms();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      value: new UntypedFormControl(
        this.plugin.config?.Incoterms?.Value ? parseInt(this.plugin.config.Incoterms.Value) : ''
      ),
      destination: new UntypedFormControl(
        this.plugin.config?.Incoterms?.Destination ? this.plugin.config.Incoterms.Destination : ''
      )
    });
  }
}
